import React from 'react';

const Visibility = ({
  isVisible,
  replacement,
  children,
}: {
  isVisible?: boolean;
  replacement?: React.ReactNode;
  children: React.ReactNode;
}) => {
  if (isVisible) {
    return <>{children}</>;
  }
  return <>{replacement}</>;
};

export default Visibility;
